import { FC, useCallback, useContext } from 'react';

import { HEADER } from '../../consts';
import { pushGTMEvent } from '../../utilities';
import { Button } from '../Button';
import { CMSProviderContext } from '../services/content';

export interface UserActionsProps {
  logInUrl?: string;
  onLoginClick?: () => void;
}

export const UserActions: FC<UserActionsProps> = ({ logInUrl, onLoginClick }) => {
  const { header } = useContext(CMSProviderContext);
  const { registerLabel, registerUrl, signInLabel } = header.data;

  const handleSignInPress = useCallback(() => {
    pushGTMEvent(HEADER, signInLabel);
    onLoginClick?.();
  }, [onLoginClick, signInLabel]);

  return (
    <>
      <Button size="md" emphasis="quaternary" styleVariant="accent" onPress={handleSignInPress} href={logInUrl} disableRouting>
        {signInLabel}
      </Button>
      <Button
        href={registerUrl}
        size="md"
        emphasis="primary"
        styleVariant="accent"
        onPress={() => pushGTMEvent(HEADER, registerLabel)}
        disableRouting
      >
        {registerLabel}
      </Button>
    </>
  );
};
